import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utilities/axios";

export const getPointedSums = createAsyncThunk(
  "pointedSums/getPointedSums",
  async (values, thunkAPI) => {
    try {
      const response = await axios.get(
        `/api/projects/${values.projectId}/account-treso/sum`,
        { params: { date: values.date } }
      );
      if (response.status === 200) {
        return response.data;
      }
      throw new Error(response.statusText);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const initialState = {
  pointedSums: [],
  isLoading: false,
  pointedSumsStatus: "idle",
};

const pointedSumsSlice = createSlice({
  name: "pointedSums",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPointedSums.pending, (state) => {
        state.pointedSumsStatus = "loading";
        state.isLoading = true;
        state.pointedSumsError = null;
      })
      .addCase(getPointedSums.fulfilled, (state, action) => {
        state.pointedSumsStatus = "succeeded";
        state.isLoading = false;
        state.pointedSumsError = null;
        state.pointedSums = action.payload.data;
      })
      .addCase(getPointedSums.rejected, (state, action) => {
        state.pointedSumsStatus = "failed";
        state.isLoading = false;
        state.pointedSumsError = action.payload;
      });
  },
});

export const reducer = pointedSumsSlice.reducer;

export default pointedSumsSlice;
